module.exports = __webpack_public_path__ + "img/zs3.b6c4541b.jpg";